module.exports = __webpack_public_path__ + "static/praising-criticizing-08b15655ef10cb241c831ca6f7652573.jpg";